/**
 * @voltxampere/engine — Resistor AC stamp (Sprint 20)
 *
 * Resistors are frequency-independent: `Y_R = 1/R + 0j`. The
 * complex stamp mirrors the DC pattern but writes to the complex
 * matrix via `(re, im)` pairs. Imaginary parts are zero.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { StampParameterError } from "@voltxampere/shared";
import { getNumericParam, getTerminalNetId } from "../terminal-utils.js";
export const resistorACStamp = (ctx, component) => {
    const resistance = getNumericParam(component, "resistance");
    if (!(resistance > 0) || !Number.isFinite(resistance)) {
        throw new StampParameterError(`resistorACStamp: component "${component.id}" has non-positive resistance ${String(resistance)}`, {
            meta: {
                stampType: "resistor",
                parameter: "resistance",
                received: resistance,
                expected: "> 0 and finite",
                componentId: component.id,
            },
        });
    }
    const g = 1 / resistance;
    const a = ctx.nodeIndex(getTerminalNetId(component, "p1"));
    const b = ctx.nodeIndex(getTerminalNetId(component, "p2"));
    ctx.addY(a, a, g, 0);
    ctx.addY(b, b, g, 0);
    ctx.addY(a, b, -g, 0);
    ctx.addY(b, a, -g, 0);
};
//# sourceMappingURL=resistor.js.map